import { FunctionComponent, PropsWithChildren } from 'react'

import styled, { css } from 'styled-components'

import { desktopCSS } from '@measures/responsive'
import { printCSS } from '@utils/style'
import useViewportTracking from '@hooks/useViewportTracking'
import { ToplistAPIProps } from '@widgets/Toplist'

interface WrapperProps extends Omit<ToplistAPIProps, 'type'> {
  onImpression?: () => void
}

type StyledWrapperProps = Pick<WrapperProps, 'hideOnDesktop'>

const StyledWrapper = styled.div<StyledWrapperProps>`
  ${({ hideOnDesktop }) => {
    return css`
      width: 100%;
      ${desktopCSS(css`
        min-height: 264px;
      `)}
      ${hideOnDesktop &&
      desktopCSS(css`
        display: none;
      `)}
      ${printCSS(css`
        display: none;
      `)}
    `
  }}
`

const Title = styled.div`
  ${({
    theme: {
      typography: {
        headings: {
          small: { bundledCSS: smallHeadingCSS },
        },
      },
      colors: { strokeBrand, textDefault },
      spacing: { spacing8 },
    },
  }) => css`
    ${smallHeadingCSS};
    color: ${textDefault};
    text-align: left;
    border-left: 2px solid ${strokeBrand};
    padding-left: ${spacing8};
    text-transform: uppercase;
  `}
`

const ChildrenContainer = styled.ol`
  ${({
    theme: {
      spacing: { spacing20, spacing16 },
    },
  }) => css`
    margin: 0;
    display: grid;
    padding-top: ${spacing20};
    box-sizing: border-box;
    width: 100%;
    padding-inline-start: 0;
    grid-template-rows: repeat(3, minmax(0, 1fr));
    grid-row-gap: ${spacing16};
  `}
`

const Wrapper: FunctionComponent<PropsWithChildren<WrapperProps>> = ({
  title,
  hideOnDesktop,
  onImpression,
  children,
}) => {
  const viewportRef = useViewportTracking({
    onImpression: onImpression ?? (() => {}),
    track: typeof onImpression === 'function',
  })

  return (
    <StyledWrapper hideOnDesktop={hideOnDesktop} ref={viewportRef}>
      <Title>{title}</Title>
      <ChildrenContainer>{children}</ChildrenContainer>
    </StyledWrapper>
  )
}

export default Wrapper
